import { useId } from 'react'
import { FieldShell } from './internal/FieldShell'
import { describedBy } from './internal/cx'

export type SelectOption = {
  value: string
  label: string
}

export type SelectProps = {
  label: string
  value: string
  onChange: (value: string) => void
  options: SelectOption[]
  error?: string
}

export function Select({ label, value, onChange, options, error }: SelectProps) {
  const fieldId = useId()
  return (
    <FieldShell id={fieldId} label={label} error={error}>
      <div className="ui-select-wrap">
        <select
          id={fieldId}
          className="ui-select"
          value={value}
          onChange={(event) => onChange(event.target.value)}
          aria-invalid={error ? true : undefined}
          aria-describedby={describedBy(error && `${fieldId}-error`)}
        >
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        <span className="ui-select-wrap__chevron" aria-hidden="true">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
            <path d="M6 9.5l6 6 6-6" />
          </svg>
        </span>
      </div>
    </FieldShell>
  )
}
